






















import {
  Component, Vue, Prop, PropSync, Watch,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import moment from 'moment';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import ToastModule from '@/store/modules/toast';

@Component({
  components: {
    Overlay,
    PrimaryButton,
    TextButton,
  },
})
export default class DatepickerModal extends Vue {
  @PropSync('dialog', {}) dialogSync!: any;

  @PropSync('isMaxDate', {}) isMaxDates!: any;

  @Prop() selectDay!: string;

  public getCurrentDate = moment().format().toString();

  private customDate: any = [];

  @Watch('selectDay', { immediate: true })
  dateSelected(val: any) {
    if (val) {
      this.customDate = [];
    }
  }

  public cancel() {
    this.dialogSync = false;
    this.customDate = [];
  }

  public async onChangeSelectDate() {
    if (this.customDate[0] > this.customDate[1]) {
      [this.customDate[0], this.customDate[1]] = [this.customDate[1], this.customDate[0]];
    }
    this.$emit('customDate', this.customDate[0], this.customDate[1]);
    this.dialogSync = false;
  }
}
